import {Component, Input, OnInit } from '@angular/core';
import { LoadingService } from './loading-service';
import { animateHide } from '../animations';

@Component({
  selector: 'app-loading-component',
  templateUrl: './loading-component.component.html',
  styleUrls: ['./loading-component.component.css'],
    animations: [
        animateHide
    ]
})
export class LoadingComponentComponent implements OnInit {
    value: any;
    constructor(public loadingService: LoadingService) {
        this.value = this.loadingService;
    }

  ngOnInit() {
  }

}
